module.exports = __webpack_public_path__ + "static/media/KOTAK.b77e5ecf.svg";